<template>
    <v-expansion-panel class="expansion">
        <v-expansion-panel-header v-slot="{ open }">
            <div class="col-12 expansionHeaderText" v-if="open">
                <p>Apply/edit the filters for the selectors inside the blocks.</p>
            </div>
            <div v-else class="col-12 expansionHeaderText">
                <h6>Filters: </h6>
                <p>{{filters.fromSoftwareNameFilter !== '' ?
                    " from software: "+filters.fromSoftwareNameFilter+",":""}}
                    {{filters.fromSoftwareVersionFilter !== '' ?
                    " from version: "+filters.fromSoftwareVersionFilter+",":""}}
                    {{filters.toSoftwareNameFilter !== '' ?
                    " to software: "+filters.toSoftwareNameFilter+",":""}}
                    {{filters.toSoftwareVersionFilter !== '' ?
                    " to version: "+filters.toSoftwareVersionFilter+",":""}}
                    {{filters.groupFilter !== '' ? " group: "+filters.groupFilter:""}} </p>
            </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
            <div class="row">
                <b-form-group
                        label="from Software Filter"
                        label-for="fromSoftwareNameFilter"
                        class="col-6">
                    <b-form-select id="fromSoftwareNameFilter"
                                   :options="filterSelectorsOptions.fromSoftwareNameFilterOptions"
                                   v-model="filters.fromSoftwareNameFilter"/>
                </b-form-group>
                <b-form-group
                        label="from Version Filter"
                        label-for="fromSoftwareVersionFilter"
                        class="col-6">
                    <b-form-select id="fromSoftwareVersionFilter"
                                   :disabled="filters.fromSoftwareNameFilter === ''"
                                   :options="fromSoftwareVersionFilterOptions"
                                   v-model="filters.fromSoftwareVersionFilter"/>
                </b-form-group>
                <b-form-group
                        label="to Software Filter"
                        label-for="toSoftwareNameFilter"
                        class="col-6">
                    <b-form-select id="toSoftwareNameFilter"
                                   :options="filterSelectorsOptions.toSoftwareNameFilterOptions"
                                   v-model="filters.toSoftwareNameFilter"/>
                </b-form-group>
                <b-form-group
                        label="to Version Filter"
                        label-for="toSoftwareVersionFilter"
                        class="col-6">
                    <b-form-select id="toSoftwareVersionFilter"
                                   :disabled="filters.toSoftwareNameFilter === ''"
                                   :options="toSoftwareVersionFilterOptions"
                                   v-model="filters.toSoftwareVersionFilter"/>
                </b-form-group>
                <b-form-group label="search for a group"
                              label-for="groupFilter"
                              class="col-12">
                    <b-form-select id="groupFilter"
                                   :options="filterSelectorsOptions.groupFilterOptions"
                                   v-model="filters.groupFilter"/>
                </b-form-group>

            </div>
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>

<script>
    import FilterBlocksService from '../../../../services/FilterBlocksService';

    export default {
        props: {
            blocks: {
                type: Array,
                default: []
            }
        },
        data() {
            return {
                filters: {
                    fromSoftwareNameFilter: '',
                    fromSoftwareVersionFilter: '',
                    toSoftwareNameFilter: '',
                    toSoftwareVersionFilter: '',
                    groupFilter: '',
                },
                filterSelectorsOptions: {
                    fromSoftwareNameFilterOptions: [],
                    toSoftwareNameFilterOptions: [],
                    groupFilterOptions: [],
                    fromSoftwareVersions: [],
                    toSoftwareVersions: [],
                },
                filteredBlockList: [],
            }
        },
        created() {
            this.filterSelectorsOptions = FilterBlocksService.getFilterLists(this.blocks);
            this.filteredBlockList = FilterBlocksService.filterBlockList(this.filters, this.blocks);
        },
        computed: {
            fromSoftwareVersionFilterOptions() {
                return FilterBlocksService.softwareVersionFilterOptions(this.filterSelectorsOptions.fromSoftwareVersions, this.filters.fromSoftwareNameFilter);
            },
            toSoftwareVersionFilterOptions() {
                return FilterBlocksService.softwareVersionFilterOptions(this.filterSelectorsOptions.toSoftwareVersions, this.filters.toSoftwareNameFilter);
            },
        },
        watch: {
            filters: {
                handler(val) {
                    if (val.fromSoftwareNameFilter === '') {
                        this.filters.fromSoftwareVersionFilter = '';
                    }
                    if (val.toSoftwareNameFilter === '') {
                        this.filters.toSoftwareVersionFilter = '';
                    }
                    this.filteredBlockList = FilterBlocksService.filterBlockList(this.filters, this.blocks);
                },
                deep: true
            },
            blocks() {
                this.filteredBlockList = FilterBlocksService.filterBlockList(this.filters, this.blocks);
            },
            filteredBlockList(val) {
                this.$emit('new-filterd-list', val);
            },
        },
    }
</script>

